/* ––
 * ––– Imports
 * –––––––––––––––––––––––––––––––– */
import Display from 'components/Generic/Display';

import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';

import PropTypes from 'prop-types';
import React from 'react';
import ReactHtmlParser from 'react-html-parser';

/* ––
 * ––– Component
 * –––––––––––––––––––––––––––––––– */
function Footer({
  logo = null, name = null, goTopTarget = '', showPrivacyPolicy = false,
}) {
  /* –– Data fetching
   * –––––––––––––––––––––––––––––––– */
  const theme = useTheme();

  /* –– Rendering methods
   * –––––––––––––––––––––––––––––––– */
  const renderTopQuickAccess = () => {
    if (!goTopTarget) { return (<Grid item xs={1} />); }

    return (
      <Grid item xs={1}>
        <Box sx={{ display: 'flex', flexDirection: 'row-reverse' }}>
          <Link href={`#${goTopTarget}`} sx={{ color: 'primary.main' }} data-testid="footer-go-top">{t('eos.company.listings.page.label.go_to_top')}</Link>
        </Box>
      </Grid>
    );
  };

  /* –– Render
   * –––––––––––––––––––––––––––––––– */
  return (
    <Container sx={{ pt: 3, pb: showPrivacyPolicy ? 2 : 3 }}>
      <Grid container spacing={2} columns={3} alignItems="center">
        <Grid item xs={1} />
        <Grid item xs={1}>
          <Box
            sx={{
              display:                        'flex',
              justifyContent:                 'center',
              alignItems:                     'center',
              '& img':                        { height: '50px' },
              [theme.breakpoints.down('sm')]: {
                '& img': { height: '35px' },
              },
            }}
          >
            <img alt={name} src={logo} sx={{ marginLeft: 'auto', marginRight: 'auto' }} data-testid="footer-company-logo" />
          </Box>
        </Grid>
        {renderTopQuickAccess()}
      </Grid>
      <Display if={showPrivacyPolicy}>
        <Grid mx={{ xs: 4, md: 2, lg: 0 }} pt={3}>
          <Typography component="div" variant="h6" color="text.primary" align="center" data-testid="footer-privacy-policy">
            {t('eos.landing_page.persistent_privacy_policy_link.info')}
            <br />
            {ReactHtmlParser(t('eos.landing_page.persistent_privacy_policy_link.click'))}
          </Typography>
        </Grid>
      </Display>
    </Container>
  );
}

/* ––
 * ––– Props declaration
 * –––––––––––––––––––––––––––––––– */
Footer.propTypes = {
  logo:              PropTypes.string,
  name:              PropTypes.string,
  goTopTarget:       PropTypes.string,
  showPrivacyPolicy: PropTypes.bool,
};

/* ––
 * ––– Exports
 * –––––––––––––––––––––––––––––––– */
export default Footer;
